module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"msg-title":"In Wartung","msg-text":"Wir werden bald zurück sein"},"fr":{"msg-title":"En cours d\u0027entretien","msg-text":"Nous serons bientôt de retour"},"it":{"msg-title":"In manutenzione","msg-text":"Saremo nuovamente a disposizione a breve"}}')
  delete Component.options._Ctor
}
